module.exports = __webpack_public_path__ + "img/2h.846b8068.png";